<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Instalaciones"
      icono="mdi-parking"
      tabla-vista="ins"
      busqueda-rapida
      titulo-crud="aparcamiento"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosInstalaciones.vue";
//import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
};
</script>

<style>
</style>